import React from "react";
import { get, isEmpty } from "lodash";
import { FormattedMessage, useIntl } from "react-intl";
import classNames from "classnames";
import { FieldFeedbackLabel } from "./FieldFeedbackLabel";
import convertString from "helpers/convertString";

const getFieldCSSClasses = (touched, errors, value) => {
  const classes = ["form-control"];
  if (touched && errors) {
    classes.push("is-invalid");
  }

  if (touched && !isEmpty(value) && !errors) {
    classes.push("is-valid");
  }

  return classes.join(" ");
};

export function Input({
  field, // { name, value, onChange, onBlur }
  form, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  label,
  withFeedbackLabel = true,
  customFeedbackLabel,
  type = "text",
  placeholder = "",
  classes,
  valueViewMode,
  showLabel = true,
  formGroup = true,
  setFieldValue,
  infoText,
  isUpperCase = false,
  customOnChange,
  ...props
}) {
  const intl = useIntl();

  const onChange = (e) => {
    const value = e?.target?.value?.toLocaleUpperCase("tr-TR");
    if (typeof customOnChange === "function") customOnChange(value);
    form?.setFieldValue(field?.name, value);
  };
  return (
    <div className={classNames(formGroup && "form-group", classes && classes)}>
      <div className="d-flex">
        {showLabel && label && (
          <label
            className={`${
              valueViewMode ? "border-bottom border-light-success border-1 font-weight-bold" : ""
            }`}
          >
            <FormattedMessage id={label} />
          </label>
        )}
        {infoText && <div className="ml-2 text-muted lms-form-info-text">{infoText}</div>}
      </div>
      {!valueViewMode ? (
        <>
          <input
            type={type}
            className={getFieldCSSClasses(
              get(form.touched, field.name),
              get(form.errors, field.name),
              field.value
            )}
            id={convertString(label)}
            placeholder={placeholder ? intl.formatMessage({ id: placeholder }) : ""}
            {...props}
            {...field}
            onChange={(e) => {
              if (isUpperCase) onChange(e);
              else {
                field?.onChange(e);
                if (typeof customOnChange === "function") customOnChange(e?.target?.value);
              }
            }}
          />
          {withFeedbackLabel && (
            <FieldFeedbackLabel
              error={get(form.errors, field.name)}
              touched={get(form.touched, field.name)}
              label={<FormattedMessage id={label} />}
              type={type}
              customFeedbackLabel={customFeedbackLabel}
            />
          )}
        </>
      ) : (
        <label>{field.value}</label>
      )}
    </div>
  );
}
